import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

enum AvailableStyles {
  blue,
  bordered,
  'bordered-blue',
}

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-tag',
  templateUrl: 'tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
  // @ts-expect-error
  @Input() closable: boolean;
  // @ts-expect-error
  @Input() selectable: boolean;
  // @ts-expect-error
  @Input() styles: string[];

  get classes(): string {
    if (!this.styles) {
      return 'label_blue';
    }
    return this.styles
      .map((style: string) => {
        if (!(style in AvailableStyles)) {
          throw new Error('Unssuported TagComponent style.');
        }
        return `label_${style}`;
      })
      .join(' ');
  }

  public handleClose() {}

  constructor() {}
}
